import DateTimeIsDisplay from './DateTimeIsDisplay'
import DateTimeIsForm from './DateTimeIsForm.container'
import IconTick from 'components/Icons/Tick'
import IconClose from 'components/Icons/Close'
import IconDateTime from 'components/Icons/DateTime'

export default {
  id: 'date_time_is',
  label: 'Date-time is',
  helpUrl: 'https://help.thinkpickle.com.au/flows/conditions/date-time-is',
  icon: IconDateTime,
  inputs: [{}],
  outputs: [
    {
      name: 'false',
      label: 'False',
      icon: IconClose,
    },
    {
      name: 'true',
      label: 'True',
      icon: IconTick,
    },
  ],
  display: DateTimeIsDisplay,
  form: DateTimeIsForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/DateTimeIs/index.js